// components/ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const ProtectedRoute = ({ redirectPath = "/auth/login" }) => {
  const { isAuthenticated,loading } = useAuth();
  // console.log("🔐 ProtectedRoute", { isAuthenticated, loading });

  if (loading) {
    return <div>Loading...</div>; // or spinner
  }
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
